import { ApiError } from '@/api';

/**
 * Traduções pt-PT (acordo ortográfico de 1990) para os enums devolvidos pela API.
 * A chave é o valor cru; usar `enumLabel` para apresentar qualquer estado/tipo ao utilizador.
 */
const enumLabels: Record<string, string> = {
  // Estado da conta
  invited: 'Convidado',
  active: 'Ativo',
  suspended: 'Suspenso',
  blocked: 'Bloqueado',
  deactivated: 'Desativado',
  inactive: 'Inativo',
  // Resultado de auditoria
  success: 'Sucesso',
  failure: 'Falha',
  denied: 'Negado',
  // Estado do acesso a aplicações
  revoked: 'Revogado',
  // Estado do pedido de acesso
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Rejeitado',
  cancelled: 'Cancelado',
  // Nível de risco de uma permissão
  low: 'Baixo',
  medium: 'Médio',
  high: 'Alto',
  critical: 'Crítico',
  // Tipo de aplicação (client OIDC)
  web: 'Web confidencial',
  spa: 'SPA pública',
  native: 'Aplicação nativa',
  // Estado do MFA (usado no cabeçalho da página de segurança)
  'mfa active': 'MFA ativo',
  'mfa inactive': 'MFA inativo',
};

export function enumLabel(value: string): string {
  return enumLabels[value.toLowerCase()] ?? value;
}

/** Mensagens pt-PT para códigos de erro da API que merecem texto orientado ao utilizador. */
const errorMessages: Record<string, string> = {
  TOO_MANY_REQUESTS: 'Demasiadas tentativas. Aguarde um momento antes de tentar novamente.',
};

/** Devolve uma mensagem pt-PT para o erro, preferindo o mapa de códigos conhecidos. */
export function errorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    const known = errorMessages[error.code];
    if (known) return known;
  }
  return error instanceof Error ? error.message : fallback;
}
